var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { BoldSpan, Card, Link, Separator } from "@atlassiansox/microscopekit";
import { errorList, statusLozenge } from "../../utils/Utils";
import SectionMessage from "@atlaskit/section-message";
import EditorOpenIcon from "@atlaskit/icon/glyph/editor/open";
import { TimeComponent } from "../TimeComponent";
export var PremiseExecutionView = function (props) {
    var parameters = props.premiseExecution.parameters;
    var name = "";
    var description = "";
    var filteredKeys = [
        "user_count",
        "ramp_up_time",
        "steady_state_time"
    ];
    if (parameters) {
        Object.entries(parameters).forEach(function (entry) {
            var _a = __read(entry, 2), key = _a[0], value = _a[1];
            if (key === "name") {
                name = value;
            }
            else if (key === "description") {
                description = value;
            }
        });
    }
    return (React.createElement("div", null,
        React.createElement(Card, null,
            React.createElement("h4", null,
                "Premise status: ",
                statusLozenge(props.premiseExecution.status)),
            React.createElement("p", null, name),
            React.createElement("p", null, description),
            props.premiseExecution.response.perf_job_url ? (React.createElement("p", null,
                "Perfview Link:",
                " ",
                React.createElement(Link, { to: props.premiseExecution.response.perf_job_url },
                    props.premiseExecution.response.perf_job_id,
                    React.createElement(EditorOpenIcon, { label: "preview" })))) : (React.createElement(React.Fragment, null)),
            parameters && (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    React.createElement(BoldSpan, null, "Parameters:")),
                React.createElement("ul", null, Object.entries(parameters)
                    .filter(function (entry) {
                    var _a = __read(entry, 1), key = _a[0];
                    return filteredKeys.indexOf(key) >= 0;
                })
                    .map(function (entry, index) {
                    var _a = __read(entry, 2), key = _a[0], value = _a[1];
                    return (React.createElement("li", { key: key + index.toString() },
                        key,
                        " : ",
                        value.toString()));
                })))),
            React.createElement(TimeComponent, { createdAt: props.premiseExecution.createdAt, updatedAt: props.premiseExecution.updatedAt, status: props.premiseExecution.status }),
            React.createElement(Separator, null),
            React.createElement("div", { hidden: errorList.indexOf(props.premiseExecution.status.toLowerCase()) < 0 },
                React.createElement(SectionMessage, { appearance: "error", title: "Execution Failed" }, props.premiseExecution.statusMessage)))));
};
